// extracted by mini-css-extract-plugin
export var headerCell = "_4n-1";
export var loadingSpinnerContainer = "_4n-4";
export var rowWrapper = "_4n-3";
export var standaloneTable = "_4n-5";
export var table = "_4n-0";
export var white = "_4n-2";